import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/main.ts' );

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {LoginNeeded, SharedModule, AccountNeeded} from '../commons/shared.module';
import {MainComponent} from './main.component';
import {AppRoutes} from '../commons/global';
import {ProfileComponent} from './profile.component';

import {NotFoundComponent} from '../root.component';
import { InitGuard } from '../init/init.guard';
import { XsModule } from '../xs/xs.module';
import { ContactComponent } from './contact.component';


const AppRouting: Routes = [

    {
        path: '', component:MainComponent, canActivate:[InitGuard],
        children: [
            { path: '', redirectTo:AppRoutes.PROJECTS, pathMatch: 'full' },
            { path: AppRoutes.PROFILE, component:ProfileComponent, pathMatch: 'full', canActivate:[AccountNeeded] },
            { path: AppRoutes.CONTACT, component:ContactComponent, pathMatch: 'full', canActivate:[AccountNeeded] },
            { path: AppRoutes.JOBS, loadChildren: () => import( './jobs/index').then(m => m.JobsModule), canActivate:[AccountNeeded] },
            { path: AppRoutes.EXPLORER, loadChildren: () => import('./explorer/index').then(m => m.ExplorerModule), canActivate:[AccountNeeded] },
            { path: AppRoutes.PROJECTS, loadChildren: () => import( './projects/index').then(m => m.DashboardModule), canActivate:[AccountNeeded]  },
            { path: AppRoutes.INSPECTOR, loadChildren: () => import( './map/index').then(m => m.MapModule), canActivate:[AccountNeeded] },
            { path: AppRoutes.ADMIN, loadChildren: () => import('./settings/index').then(m => m.SettingsModule), canActivate:[LoginNeeded] },
            { path: '**', component: NotFoundComponent }

    ]}
];


@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        XsModule,
        RouterModule.forChild(AppRouting)
    ],
    providers: [InitGuard],
    declarations: [
        MainComponent,
        ProfileComponent,
        ContactComponent
    ]
    
})
export class MainModule {
}
